// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  line-height: 1.6;
  color: #334155;
  background-color: #f8fafc;
}

.App {
  min-height: 100vh;
}

/* Custom animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fadeIn 0.5s ease-out;
}

/* Enhanced button hover effects */
.btn-hover-scale {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.btn-hover-scale:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Card animations */
.card-hover {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.card-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

/* Loading spinner */
.spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Responsive utilities */
@media (max-width: 640px) {
  .grid-responsive {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

/* Status indicators */
.status-working {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.status-off {
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
}

/* Custom scrollbar */
.custom-scroll {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f1f5f9;
}

.custom-scroll::-webkit-scrollbar {
  width: 6px;
}

.custom-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Gradient backgrounds */
.gradient-primary {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
}

.gradient-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.gradient-warning {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

/* Typography enhancements */
.text-gradient {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Form enhancements */
.form-focus {
  transition: all 0.2s ease;
}

.form-focus:focus {
  transform: scale(1.02);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Badge animations */
.badge-pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* Modern glass effect */
.glass {
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Enhanced shadows */
.shadow-soft {
  box-shadow: 0 2px 15px -3px rgba(0, 0, 0, 0.07), 0 10px 20px -2px rgba(0, 0, 0, 0.04);
}

.shadow-strong {
  box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.15);
}

/* Improved spacing */
.spacing-section {
  padding: 2rem 0;
}

.spacing-component {
  margin-bottom: 1.5rem;
}

/* Interactive elements */
.interactive {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.interactive:active {
  transform: scale(0.98);
}

/* Modern borders */
.border-modern {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

/* Status colors */
.text-success {
  color: #10b981;
}

.text-warning {
  color: #f59e0b;
}

.text-error {
  color: #ef4444;
}

.bg-success-light {
  background-color: #d1fae5;
}

.bg-warning-light {
  background-color: #fef3c7;
}

.bg-error-light {
  background-color: #fee2e2;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,0DAA0D;EAC1D,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kCAAkC;AAClC;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,oBAAoB;AACpB;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,oBAAoB;AACpB;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA,sBAAsB;AACtB;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,4BAA4B;AAC5B;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA,qBAAqB;AACrB;EACE,qFAAqF;AACvF;;AAEA;EACE,iDAAiD;AACnD;;AAEA,qBAAqB;AACrB;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\n  line-height: 1.6;\n  color: #334155;\n  background-color: #f8fafc;\n}\n\n.App {\n  min-height: 100vh;\n}\n\n/* Custom animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-fade-in {\n  animation: fadeIn 0.5s ease-out;\n}\n\n/* Enhanced button hover effects */\n.btn-hover-scale {\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.btn-hover-scale:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* Card animations */\n.card-hover {\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.card-hover:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n}\n\n/* Loading spinner */\n.spinner {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive utilities */\n@media (max-width: 640px) {\n  .grid-responsive {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n}\n\n/* Status indicators */\n.status-working {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n}\n\n.status-off {\n  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);\n}\n\n/* Custom scrollbar */\n.custom-scroll {\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 #f1f5f9;\n}\n\n.custom-scroll::-webkit-scrollbar {\n  width: 6px;\n}\n\n.custom-scroll::-webkit-scrollbar-track {\n  background: #f1f5f9;\n}\n\n.custom-scroll::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.custom-scroll::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Gradient backgrounds */\n.gradient-primary {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n}\n\n.gradient-success {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n}\n\n.gradient-warning {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n}\n\n/* Typography enhancements */\n.text-gradient {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Form enhancements */\n.form-focus {\n  transition: all 0.2s ease;\n}\n\n.form-focus:focus {\n  transform: scale(1.02);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Badge animations */\n.badge-pulse {\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n/* Modern glass effect */\n.glass {\n  backdrop-filter: blur(10px);\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n/* Enhanced shadows */\n.shadow-soft {\n  box-shadow: 0 2px 15px -3px rgba(0, 0, 0, 0.07), 0 10px 20px -2px rgba(0, 0, 0, 0.04);\n}\n\n.shadow-strong {\n  box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.15);\n}\n\n/* Improved spacing */\n.spacing-section {\n  padding: 2rem 0;\n}\n\n.spacing-component {\n  margin-bottom: 1.5rem;\n}\n\n/* Interactive elements */\n.interactive {\n  cursor: pointer;\n  user-select: none;\n}\n\n.interactive:active {\n  transform: scale(0.98);\n}\n\n/* Modern borders */\n.border-modern {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n}\n\n/* Status colors */\n.text-success {\n  color: #10b981;\n}\n\n.text-warning {\n  color: #f59e0b;\n}\n\n.text-error {\n  color: #ef4444;\n}\n\n.bg-success-light {\n  background-color: #d1fae5;\n}\n\n.bg-warning-light {\n  background-color: #fef3c7;\n}\n\n.bg-error-light {\n  background-color: #fee2e2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
